// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'
import { bxAnaalyse } from '@/core/icons'

// 隐藏生产 菜单
/* let hideProd = false
if (process.env.VUE_APP_BUILD_TARGET === 'prod') {
  hideProd = true
} */

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: 'Home' },
    redirect: '/dashboard/workplace',
    children: [
      // dashboard
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { title: 'Dashboard', keepAlive: true, icon: bxAnaalyse },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import('@/views/dashboard/Workplace'),
            meta: { title: 'Workplace', keepAlive: false }
          }
        ]
      },
      // OBS资料管理
      {
        path: '/obs',
        name: 'OBS',
        component: PageView,
        redirect: '/obs/booking/list',
        meta: { title: 'OBS', icon: 'read', permission: [ 'DEMO' ]},
        children: [
          {
            path: '/obs/booking/list',
            name: 'BookPage',
            component: () => import('@/views/obs/booking/BookPage'),
            meta: { title: 'Booking List', keepAlive: false, hidden: false, hiddenHeaderContent: false }
          }
        ]
      },
      // 客户资料管理 生产
      {
        path: '/cdb',
        name: 'CDB',
        component: PageView,
        redirect: '/cdb/customer/list',
        meta: { title: 'CDB MGMT', icon: 'tool', permission: [ 'CDB' ]},
        hidden: true,
        // hidden: !hideProd,
        children: [
          // 客户资料管理
          {
            path: '/cdb/customer/list',
            name: 'CdbCustomerManage',
            component: () => import('@/views/cdb/customer/CdbCustomerPage'),
            meta: { title: 'Customer Profile', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'CDB_CUSTOMER' ]}
          },
          // 会员资料管理
          {
            path: '/cdb/member/list',
            name: 'CdbMemberrship',
            component: () => import('@/views/cdb/member/MembershipPage'),
            meta: { title: 'Membership', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'CDB_MEMBERSHIP' ]}
          },
          // 直接对客户资料进行编辑的页面
          {
            path: '/cdb/customer/edit/:customerIdOrCode',
            name: 'EditCdbCustomerPage',
            component: () => import('@/views/cdb/customer/EditCdbCustomerPage'),
            hidden: true,
            meta: { title: 'Customer Profile', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'CDB_CUSTOMER' ]}
          },
          {
            path: '/cdb/member/edit/:membershipIdOrCode',
            name: 'EditMembershipPage',
            component: () => import('@/views/cdb/member/EditMembershipPage'),
            hidden: true,
            meta: { title: 'Member Profile', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'CDB_MEMBERSHIP' ]}
          },
          // 删除恢复
          {
            path: '/cdb/customer/trash/list',
            name: 'CdbCustomerTrashPage',
            component: () => import('@/views/cdb/customertrash/CustomerTrashPage'),
            meta: { title: 'Customer Trash', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'CDB_CUSTOMER_TRASH' ]}
          },
          // 删除恢复优惠券
          // {
          //   path: '/cdb/customer/coupons/list',
          //   name: 'CdbCouponsTrashPage',
          //   component: () => import('@/views/cdb/customertrash/CustomerTrashPage'),
          //   meta: { title: 'Coupons Trash', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ '' ]}
          // },
        ]
      },
      // 客户资料管理 测试 hideProd
      {
        path: '/cdbnew',
        name: 'CDBNew',
        component: PageView,
        redirect: '/cdbnew/customer/list',
        meta: { title: 'CDB MGMT', icon: 'tool', permission: [ 'CDB' ]},
        // hidden: hideProd,
        children: [
          // 客户资料管理
          {
            path: '/cdbnew/customer/list',
            name: 'CdbCustomerManageNew',
            component: () => import('@/views/cdbnew/customernew/CdbCustomerPage'),
            meta: { title: 'Customer Profile', keepAlive: false, hidden: true, hiddenHeaderContent: true, permission: [ 'CDB_CUSTOMER' ]}
          },
          // 会员资料管理
          {
            path: '/cdbnew/member/list',
            name: 'CdbMemberrshipNew',
            component: () => import('@/views/cdbnew/member/MembershipPage'),
            meta: { title: 'Membership', keepAlive: false, hidden: false, hiddenHeaderContent: true, permission: [ 'CDB_MEMBERSHIP' ]}
          },
          // 直接对客户资料进行编辑的页面
          {
            path: '/cdbnew/customer/edit/:customerIdOrCode',
            name: 'EditCdbCustomerPageNew',
            component: () => import('@/views/cdbnew/customernew/EditCdbCustomerPage'),
            hidden: true,
            meta: { title: 'Customer Profile', keepAlive: false, hidden: false, hiddenHeaderContent: true, permission: [ 'CDB_CUSTOMER' ]}
          },
          {
            path: '/cdbnew/member/edit/:membershipIdOrCode',
            name: 'EditMembershipPageNew',
            component: () => import('@/views/cdbnew/member/EditMembershipPage'),
            hidden: true,
            meta: { title: 'Member Profile', keepAlive: false, hidden: false, hiddenHeaderContent: true, permission: [ 'CDB_MEMBERSHIP' ]}
          },
          // 删除恢复
          {
            path: '/cdbnew/customer/trash/list',
            name: 'CdbCustomerTrashPageNew',
            component: () => import('@/views/cdbnew/customertrash/CustomerTrashPage'),
            meta: { title: 'Customer Trash', keepAlive: false, hidden: false, hiddenHeaderContent: true, permission: [ 'CDB_CUSTOMER_TRASH' ]}
          },
        ]
      },
      // 酒店管理
      {
        path: '/op',
        name: 'OP',
        component: PageView,
        redirect: '/op/hotel/list',
        meta: { title: 'OP', icon: 'read', permission: [ 'DEMO' ]},
        children: [
          {
            path: '/op/hotel/list',
            name: 'Hotel',
            component: () => import('@/views/op/hotel/HotelPage'),
            meta: { title: 'Hotel', keepAlive: false, hidden: false, hiddenHeaderContent: false}
          }
        ]
      },
      // Dict数据字典管理
      {
        path: '/dict',
        name: 'DictSetting',
        component: PageView,
        redirect: '/dict/language/list',
        meta: { title: 'Dict Setting', icon: 'switcher', permission: [ 'DICT' ]},
        children: [
          // language
          {
            path: '/dict/language/list',
            name: 'DictLanguage',
            component: () => import('@/views/dict/language/LanguagePage'),
            meta: { title: 'Language', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'DICT_LANGUAGE' ]}
          },
          // meal request
          {
            path: '/dict/mealrequest/list',
            name: 'CdbMealRequest',
            component: () => import('@/views/dict/mealrequest/MealrequestPage'),
            meta: { title: 'Meals Restriction', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'DICT_CDB_MEAL_REQUEST' ]}
          },
          // special request
          {
            path: '/dict/specialrequest/list',
            name: 'CdbSpecialRequest',
            component: () => import('@/views/dict/specialrequest/SpecialrequestPage'),
            meta: { title: 'Special Request', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'DICT_CDB_SPECIAL_REQUEST' ]}
          },
          // Travel doc
          {
            path: '/dict/traveldoc/list',
            name: 'CdbTravelDoc',
            component: () => import('@/views/dict/traveldoc/TraveldocPage'),
            meta: { title: 'Travel Doc', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'DICT_TRAVEL_DOC' ]}
          },
          // Dict Origin
          {
            path: '/dict/origin/list',
            name: 'CdbOrigin',
            component: () => import('@/views/dict/origin/OriginPage'),
            meta: { title: 'Origin', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'DICT_ORIGIN' ]}
         },
         // ethnicities
         {
          path: '/dict/ethnicities/list',
          name: 'DictEthnicities',
          component: () => import('@/views/dict/ethnicities/EthnicitiesPage'),
          meta: { title: 'Ethnicities', keepAlive: false, hidden: false, hiddenHeaderContent: false, permission: [ 'DICT_ETHNICITIES' ]}
        },
        ]
      },
      // 基础数据设定
      {
        path: '/basic',
        name: 'Basic',
        component: PageView,
        redirect: '/basic/country/list',
        meta: { title: 'Basic Setting', icon: 'appstore', permission: [ 'BD' ] },
        children: [
          // 机场管理
          {
            path: '/basic/aiport/list',
            name: 'AirportManage',
            component: () => import('@/views/basic/airport/AirportPage'),
            meta: { title: 'Airport', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_AIRPORT' ] }
          },
          // 供应商管理
          {
            path: '/basic/supplier/list',
            name: 'SupplierManage',
            component: () => import('@/views/basic/supplier/SupplierPage'),
            meta: { title: 'Supplier', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_SUPPLIER' ] }
          },
          // 巴士公司管理
          {
            path: '/basic/buscompany/list',
            name: 'BusCompanyManage',
            component: () => import('@/views/basic/buscompany/BusCompanyPage'),
            meta: { title: 'BusCompany', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_BUSCOMPANY' ] }
          },
          // 国家管理
          {
            path: '/basic/country/list',
            name: 'CountryManage',
            component: () => import('@/views/basic/country/CountryPage'),
            meta: { title: 'Country', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_COUNTRY' ] }
          },
          // 州管理
          {
            path: '/basic/state/list',
            name: 'StateManage',
            component: () => import('@/views/basic/state/StatePage'),
            meta: { title: 'State/Province', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_STATE' ] }
          },
          // 城市管理
          {
            path: '/basic/city/list',
            name: 'CityManage',
            component: () => import('@/views/basic/city/CityPage'),
            meta: { title: 'City', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_CITY' ] }
          },
          // 货币管理
          {
            path: '/basic/currency/list',
            name: 'CurrencyManage',
            component: () => import('@/views/basic/currency/CurrencyPage'),
            meta: { title: 'Currency', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_CURRENCY' ] }
          },
          // 销售部门
          {
            path: '/basic/salesdivision/list',
            name: 'SalesDivisionManage',
            component: () => import('@/views/basic/salesdivision/SalesDivisionPage'),
            meta: { title: 'Sales Division', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'BD_SALES_DIVISION' ] }
          }
        ]
      },
      // 行政管理
      {
        path: '/adm',
        name: 'ADM',
        component: PageView,
        redirect: '/adm/department/list',
        meta: { title: 'ADM MGMT', icon: 'share-alt', permission: [ 'ADM' ] },
        children: [
          // 部门管理
          {
            path: '/adm/department/list',
            name: 'DepartmentManage',
            component: () => import('@/views/adm/department/DepartmentPage'),
            meta: { title: 'Department', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'ADM_DEPARTMENT' ] }
          },
          // 员工管理
          {
            path: '/adm/employee/list',
            name: 'EmployeeManage',
            component: () => import('@/views/adm/employee/EmployeePage'),
            meta: { title: 'Employee', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'ADM_EMPLOYEE' ] }
          }
        ]
      },
      // 系统设置
      {
        path: '/system',
        name: 'System',
        component: PageView,
        redirect: '/system/adminer/list',
        meta: { title: 'System MGMT', icon: 'setting', permission: [ 'SYS' ] },
        children: [
          // 管理员管理
          {
            path: '/system/adminer/list',
            name: 'AdminerManage',
            component: () => import('@/views/system/adminer/AdminerPage'),
            meta: { title: 'Adminer', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'SYS_ADMINER' ] }
          },
          // 角色管理
          {
            path: '/system/role/list',
            name: 'RoleManage',
            component: () => import('@/views/system/role/RolePage'),
            meta: { title: 'Role', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'SYS_ROLE' ] }
          },
          // 权限管理
          {
            path: '/system/permission/list',
            name: 'PermissionManage',
            component: () => import(/* webpackChunkName: "result" */ '@/views/system/permission/PermissionPage'),
            meta: { title: 'Permission', keepAlive: false, hidden: true, hiddenHeaderContent: false, permission: [ 'SYS_PERMISSION' ] }
          }
        ]
      },
      // account
      {
        path: '/account',
        component: RouteView,
        redirect: '/account/center',
        name: 'account',
        meta: { title: 'Personal', icon: 'user', keepAlive: true },
        children: [
          {
            path: '/account/settings',
            name: 'settings',
            component: () => import('@/views/account/settings/Index'),
            meta: { title: 'Setting', hideHeader: true },
            redirect: '/account/settings/base',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/account/settings/base',
                name: 'BaseSettings',
                component: () => import('@/views/account/settings/BaseSetting'),
                meta: { title: 'Basic Setting', hidden: true }
              },
              {
                path: '/account/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/account/settings/Security'),
                meta: { title: 'Security Setting', hidden: true, keepAlive: true }
              },
              {
                path: '/account/settings/custom',
                name: 'CustomSettings',
                component: () => import('@/views/account/settings/Custom'),
                meta: { title: '个性化设置', hidden: true, keepAlive: true }
              },
              {
                path: '/account/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/account/settings/Binding'),
                meta: { title: '账户绑定', hidden: true, keepAlive: true }
              },
              {
                path: '/account/settings/notification',
                name: 'NotificationSettings',
                component: () => import('@/views/account/settings/Notification'),
                meta: { title: '新消息通知', hidden: true, keepAlive: true }
              }
            ]
          }
        ]
      },
      // Exception
      {
        path: '/exception',
        name: 'Exception',
        component: RouteView,
        redirect: '/exception/403',
        meta: { title: '异常页', icon: 'warning', permission: [ 'DEV_DEMO' ] },
        children: [
          {
            path: '/exception/403',
            name: 'Exception403',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403'),
            meta: { title: '403', permission: [ 'DEV_DEMO' ] }
          },
          {
            path: '/exception/404',
            name: 'Exception404',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
            meta: { title: '404', permission: [ 'DEV_DEMO' ] }
          },
          {
            path: '/exception/500',
            name: 'Exception500',
            component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500'),
            meta: { title: '500', permission: [ 'DEV_DEMO' ] }
          }
        ]
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'portalLogin',
        name: 'PortalLogin',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/PortalLogin')
      }
    ]
  },
  {
    path: '/404',
    name:'NotFound',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '/payment-authorization/:paymentId',
    name: 'PaymentAuthorizationPage',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/paymentauthorization/PaymentAuthorization')
  }
]
